import React from 'react';
import styled from '@benzinga/themetron';

interface Props {
  className?: string;
  label: string;
  style?: React.CSSProperties;
  url: string;
}

const StyledListItem = styled.li`
  margin-top: 0;
  padding-top: 10px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 21px;
  text-decoration: none;
`;

const StyledAnchor = styled.a`
  transition:
    color 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    color 0.2s ease;
  text-decoration: none;
`;

const FooterLink: React.FC<Props> = ({ label, url }) => (
  <StyledListItem className="footer-link">
    <StyledAnchor data-action={`Footer Link Click - ${label}`} href={url}>
      {label}
    </StyledAnchor>
  </StyledListItem>
);

export default FooterLink;
